import { render } from "./foot.vue?vue&type=template&id=1da72b43"
const script = {}

import "./foot.vue?vue&type=style&index=0&id=1da72b43&lang=scss"

import exportComponent from "D:\\A-wy-work\\wy-vue-source\\wy-saas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__